import {PostOdontoBookingConfirmParams} from 'domain/usecases';
import {makePostOdontoBookingConfirm} from 'main/factories/usecases';

export async function postOdontoBookingConfirm(params: PostOdontoBookingConfirmParams) {
	const response = await makePostOdontoBookingConfirm().post(params);

	return response;
}
